import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../../lib/content";

export const Services = () => (
  <section id="servicos" className="relative py-24 md:py-36 scroll-mt-20" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Overline>{SERVICES.overline}</Overline>
        <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight max-w-3xl">
          {SERVICES.title}
        </h2>
        <p className="mt-5 max-w-xl text-white/55 text-lg">{SERVICES.subtitle}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
        {SERVICES.items.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span}>
              <div className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-bf-surface p-8 hover:border-bf-teal/50 transition-colors duration-300">
                <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-bf-teal/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-white/5 text-bf-yellow ring-1 ring-white/10">
                  <Icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="relative mt-6 font-display text-2xl font-bold tracking-tight">{s.title}</h3>
                <p className="relative mt-3 text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
